export default __webpack_public_path__ + "static/HelveticaNeueLTStd-MdCn-2095f659f6e094b32c3e95b667ae2147.woff2";